import { Answers, ScreenGroups, Screens } from '@src/containers/QuizContainer/types';
import {
	QuizMappingType,
	defaultScreenGroupOrder,
	defaultScreenMap,
} from '@src/containers/QuizContainer/screenMapping';
import { datadogRum } from '@datadog/browser-rum';

export interface QuizReducerInterface {
	answers: Answers;
	screenGroupOrder: ScreenGroups[];
	screenHistory: Screens[];
	screenMapping: QuizMappingType;
	sessionRecs: number[];
	welcomeSequence: Screens[];
}

export type QuizActionTypes = {
	answers?: Answers;
	screenGroupOrder?: ScreenGroups[];
	screenHistory?: Screens[];
	screenMapping?: QuizMappingType;
	sessionRecs?: number[];
	welcomeSequence?: Screens[];
	type:
		| 'reset_quiz_state'
		| 'set_initial_quiz_state'
		| 'set_session_recs'
		| 'updated_answers'
		| 'updated_screen_history';
};

export const quizInitialState: QuizReducerInterface = {
	answers: {},
	screenGroupOrder: defaultScreenGroupOrder,
	screenHistory: [Screens.OPTIN],
	screenMapping: defaultScreenMap,
	sessionRecs: [],
	welcomeSequence: [Screens.OPTIN],
};

export const quizReducer = (state: QuizReducerInterface, action: QuizActionTypes) => {
	switch (action.type) {
		case 'reset_quiz_state': {
			return {
				...state,
				answers: {},
				screenHistory: state.welcomeSequence,
				sessionRecs: [],
			};
		}
		case 'set_initial_quiz_state': {
			return {
				...state,
				screenGroupOrder: action.screenGroupOrder,
				screenHistory: action.screenHistory,
				screenMapping: action.screenMapping,
				welcomeSequence: action.welcomeSequence,
			};
		}
		case 'set_session_recs': {
			return {
				...state,
				sessionRecs: action.sessionRecs,
			};
		}
		case 'updated_answers': {
			return {
				...state,
				answers: action.answers,
			};
		}
		case 'updated_screen_history': {
			return {
				...state,
				screenHistory: action.screenHistory,
			};
		}

		default:
			datadogRum.addError('Unknown action', {
				catalogReducerAction: `${action.type}`,
				catalogContext: 'quizReducer',
			});
			throw Error(`Unknown action: ${action.type}`);
	}
};
